import React, { Component, Fragment } from 'react';
import { get, map } from 'lodash';
import axios from 'axios';
import { API_HOST, UserContext } from '../../consts';
import 'react-circular-progressbar/dist/styles.css';
import Ruler from '../../components/Ruler';
import Loading from '../../components/Loading';
import TabsHomePage from '../../components/TabsHomePage';
import bannerRelatorios from '../../assets/images/plurall_images/banner2.png';
import { Container, Grid } from '@material-ui/core';
import PieChartIcon from '@material-ui/icons/PieChart';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { ItemTotal, ItemTotalCalibrado } from './styles';
import { withTheme } from 'styled-components';
import CardHomePage from '../../components/CardHomePage';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import {
  ClickCard,
  ClickCardAction
} from '../../utils/googleAnalytics/events/EventCardHomePage';
import IconCarreiras from '../../assets/images/homePage/carteiras.svg';
import IconCreateitens from '../../assets/images/homePage/createitens.svg';
import IconExam from '../../assets/images/homePage/exam.svg';
import IconListchack from '../../assets/images/homePage/listcheck.svg';
import IconVideocreate from '../../assets/images/homePage/videocreate.svg';
import IconVideos from '../../assets/images/homePage/videos.svg';
import IconRobot from '../../assets/images/homePage/robot.svg';
import IconResult from '../../assets/images/homePage/result.svg';
import ContainerCalendario from '../../components/portal/Calendario/ContainerCalendario'
import ContainerSection from '../../components/portal/ContainerSection'

const LIMITE_AREAS_CONHECIMENTO = 20;

class HomePage extends Component {
  state = {
    itens: [],
    atividades: [],
    tipoCurso: [],
    areaConhecimento: [],
    tipoExame: [],
    componenteCurricular: [],
    mostrarTodasAreasConhecimento: false,
    mostrarTodastipos: false,
    mostrarTodosCursos: false,
    mostrarTodosPeriodos: false,
    mostrarTodosExames: false,
    metadataModels: [],
    fetchingExames: true,
    fetchingAreaConhecimento: true,
    fetchingCurso: true,
    fetchingComponenteCurricular: true,
    fetchingItens: true,
    fetchingAtividades: true,
    encomendas: []
  };

  componentDidMount() {
    this.fetchItens();
    this.fetchAtividades();
    this.fetchEncomendas();
    this.fetchComponenteCurricular();
    this.fetchAreaConhecimento();
    this.fetchCurso();
    this.fetchExame();
    this.fetchMetadata();
  }

  fetchComponenteCurricular() {
    axios.get(`${API_HOST}/core/componente_curricular`).then((response) => {
      this.setState({
        componenteCurricular: response.data,
        fetchingComponenteCurricular: false
      });
    });
  }
  fetchExame() {
    axios.get(`${API_HOST}/core/exame`).then((response) => {
      this.setState({ tipoExame: response.data, fetchingExames: false });
    });
  }
  fetchCurso() {
    axios.get(`${API_HOST}/core/curso`).then((response) => {
      this.setState({ tipoCurso: response.data, fetchingCurso: false });
    });
  }
  fetchAreaConhecimento() {
    axios.get(`${API_HOST}/core/area_conhecimento`).then((response) => {
      this.setState({
        areaConhecimento: response.data,
        fetchAreaConhecimento: false
      });
    });
  }
  fetchAtividades() {
    axios.get(`${API_HOST}/avaliacoes/avaliacao`).then((response) => {
      this.setState({ atividades: response.data, fetchingAtividades: false });
    });
  }

  fetchItens() {
    axios.get(`${API_HOST}/dashboards/itens`).then((response) => {
      this.setState({ itens: response.data, fetchingItens: false });
    });
  }

  fetchEncomendas() {
    axios.get(`${API_HOST}/encomenda/encomenda/dashboard`).then((response) => {
      this.setState({ encomendas: response.data });
    });
  }

  goToExams() {
    axios.get(`${API_HOST}/core/get-token/integra`).then((response) => {
      window.location.href = `https://exams-sesi-avaliacao-2022.didatti.net.br/external-auth/SESI/token/${response.data.token}`;
    });
  }

  mostrarAreasConhecimento = () => {
    const { mostrarTodasAreasConhecimento } = this.state;
    this.setState({
      mostrarTodasAreasConhecimento: !mostrarTodasAreasConhecimento
    });
  };

  mostrarPeriodos = () => {
    const { mostrarTodosPeriodos } = this.state;
    this.setState({ mostrarTodosPeriodos: !mostrarTodosPeriodos });
  };
  mostrarExames = () => {
    const { mostrarTodosExames } = this.state;
    this.setState({ mostrarTodosExames: !mostrarTodosExames });
  };

  mostrarCurso = () => {
    const { mostrarTodosCursos } = this.state;
    this.setState({ mostrarTodosCursos: !mostrarTodosCursos });
  };
  mostrarTipos = () => {
    const { mostrarTodosTipos } = this.state;
    this.setState({ mostrarTodosTipos: !mostrarTodosTipos });
  };

  shouldDisplay = (field) => {
    const { metadata } = this.state;
    return get(metadata, field) > 0;
  };

  mapMetadata = (metadata) => {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });
    return mapped;
  };

  fetchMetadata = () => {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(
        `${API_HOST}/params/param?model=${this.state.metadataModels.join('|')}`
      )
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  };

  analytcsClick = (name) => {
    let label = 'Click' + ': ' + name;

    TrackGoogleAnalyticsEvent(ClickCard, ClickCardAction, label);
  };

  renderItens() {
    const {
      itens,
      mostrarTodasAreasConhecimento,
      mostrarTodosPeriodos,
      mostrarTodosCursos,
      mostrarTodosTipos,
      mostrarTodosExames,
      atividades,
      fetchingItens,
      fetchingAtividades,
      fetchingComponenteCurricular,
      fetchingCurso,
      fetchingAreaConhecimento,
      fetchingExames
    } = this.state;
    const { history } = this.props;
    const exames = get(itens, 'exames');
    const total = get(itens, 'total');
    const calibrados = get(itens, 'calibrados');
    let areas_conhecimento = get(itens, 'areas_conhecimento') || [];
    let periodo = get(itens, 'periodo') || [];
    let curso = get(itens, 'curso') || [];
    let tipo = get(itens, 'tipo') || [];
    let soma_area_conhecimento = get(itens, 'soma_area_conhecimento') || [];
    let soma_periodo = get(itens, 'soma_periodo') || [];
    let soma_curso = get(itens, 'soma_curso') || [];
    let soma_tipo = get(itens, 'soma_tipo') || [];
    let soma_exame = get(itens, 'soma_exame') || [];
    let count = get(atividades, 'count') || [];
    let soma_areas_do_conhecimento =
      get(itens, 'soma_areas_do_conhecimento') || [];
    let areas_do_conhecimento = get(itens, 'areas_do_conhecimento') || [];
    let nivel_curso = get(itens, 'nivel_curso') || [];
    let soma_nivel_curso = get(itens, 'soma_nivel_curso') || [];
    let componente_curricular = get(itens, 'componente_curricular');
    let soma_componente_curricular = get(itens, 'soma_componente_curricular');

    const dadosCards = [
      {
        id: 1,
        subTitle: 'RELATÓRIO DE',
        nome: 'Diagnóstico de Proficiênia por Habilidade',
        url: '/filter-turmas/habilidade'
      },
      {
        id: 2,
        subTitle: 'RELATÓRIO DE',
        nome: 'Distribuição Percentual dos Alunos nos Níveis da Escala de Proficiência',
        url: '/filter-distribuicao-proficiencia-aluno'
      },
      {
        id: 3,
        subTitle: 'RELATÓRIO DE',
        nome: 'Nota e Proficiência dos Alunos por Turmas',
        url: '/filter-turmas'
      },
      {
        id: 4,
        subTitle: 'RELATÓRIOS',
        nome: 'Individuais do Aluno',
        url: '/filter-aluno'
      },
      {
        id: 5,
        subTitle: 'RELATÓRIO DE',
        nome: 'DRE',
        url: '/filter-dres'
      }
    ];

    if (!mostrarTodasAreasConhecimento) {
      areas_conhecimento = areas_conhecimento.slice(
        0,
        LIMITE_AREAS_CONHECIMENTO
      );
    }
    if (!mostrarTodosPeriodos) {
      periodo = periodo.slice(0, LIMITE_AREAS_CONHECIMENTO);
    }

    if (!mostrarTodosCursos) {
      curso = curso.slice(0, LIMITE_AREAS_CONHECIMENTO);
    }

    if (!mostrarTodosTipos) {
      tipo = tipo.slice(0, LIMITE_AREAS_CONHECIMENTO);
    }
    if (!mostrarTodosExames) {
      tipo = tipo.slice(0, LIMITE_AREAS_CONHECIMENTO);
    }
    const Accordion = withStyles({
      root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
          borderBottom: 0
        },
        '&:before': {
          display: 'none'
        },
        '&$expanded': {
          marginTop: '10px',
          marginBottom: '10px',
          margin: 'auto'
        }
      },
      expanded: {}
    })(MuiAccordion);
    const AccordionSummary = withStyles({
      root: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        border: '1px solid #F7F7F7',
        borderRadius: '4px',
        marginBottom: -1,
        boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
        '&$expanded': {
          minHeight: 56
        }
      },
      content: {
        '&$expanded': {
          margin: '12px 0'
        }
      },
      expanded: {}
    })(MuiAccordionSummary);

    const AccordionDetails = withStyles((theme) => ({
      root: {
        padding: theme.spacing(2),
        border: '1px solid #F7F7F7',
        borderRadius: '0 0 4px 4px'
      }
    }))(MuiAccordionDetails);

    return (
      <>
        <UserContext.Consumer>
          {({ user }) => (
            <Container maxWidth="lg">
              <Grid container item spacing={3}>
                <Grid item xs={12}>
                  <h1
                    style={{
                      marginTop: '25px',
                      fontSize: '30px',
                      fontWeight: 'bold'
                    }}
                  >
                    Olá, {get(user, 'last_name')}
                  </h1>
                  {!itens.change_layout ? (
                    <>
                      <label
                        style={{
                          color: '#a6a6a6',
                          fontWeight: 'bold',
                          marginRight: '1rem'
                        }}
                      >
                        {get(user, 'email')}
                      </label>
                    </>
                  ) : (
                    <label
                      style={{
                        color: '#a6a6a6',
                        fontWeight: 'bold',
                        padding: '0px'
                      }}
                    >
                      Escolha o relatório que deseja analisar
                    </label>
                  )}
                </Grid>
              </Grid>
            </Container>
          )}
        </UserContext.Consumer>

        {!itens.change_layout ? (
          <>
            <Grid container spacing={2} style={{ padding: '20px' }}>
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    img={IconExam}
                    title="Acompanhar trilhas adaptativas, avaliações e atividades"
                    subtitle="Acesse a lista de trilhas adaptativas, avaliações e atividades aplicadas por você."
                    theme={this.props.theme.primary}
                    history={history}
                    link="exams/dashboard"
                    onClick={() => {
                      this.analytcsClick(
                        'Acompanhar trilhas adaptativas, avaliações e atividades'
                      );
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    imgResults={IconResult}
                    title="Buscar trilhas adaptativas, avaliações e atividades"
                    subtitle="Acesse a lista de trilhas adaptativas, avaliações e atividades e realize a sua busca."
                    theme={this.props.theme.primary}
                    link="instrumentos-cognitivos/tipo/1?Modal=True"
                    history={history}
                    onClick={() => {
                      this.analytcsClick(
                        'Buscar trilhas adaptativas, avaliações e atividades'
                      );
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    imgListchack={IconListchack}
                    title="Criar atividades"
                    subtitle="Crie suas atividades, adicionando recursos pedagógicos e itens criados por você ou por outros especialistas."
                    theme={this.props.theme.primary}
                    link={
                      this.shouldDisplay('avaliacao.exam_type')
                        ? 'instrumentos-cognitivos/new/dados'
                        : 'instrumentos-cognitivos/new/dados/tipo/3'
                    }
                    history={history}
                    onClick={() => {
                      this.analytcsClick('Criar atividades');
                    }}
                  />
                </Grid>
              </>

              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    img={IconCarreiras}
                    title="Buscar itens"
                    subtitle="Acesse o banco de itens e encontre o que você procura."
                    theme={this.props.theme.primary}
                    history={history}
                    link="itens/tipo/1?Modal=True"
                    onClick={() => {
                      this.analytcsClick('Buscar itens');
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    img={IconCreateitens}
                    title="Criar itens"
                    subtitle="Crie itens que poderão ser utilizados em suas atividades."
                    theme={this.props.theme.primary}
                    history={history}
                    link="itens/new/dados/tipo/1"
                    onClick={() => {
                      this.analytcsClick('Criar itens');
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    imgRobot={IconRobot}
                    title="Professor Assistente eduCAT | Avaliações"
                    subtitle="Acesse o PAE, a inteligência artificial para a criação de avaliações."
                    theme={this.props.theme.primary}
                    history={history}
                    link="/personal-create/6/avaliacao/new"
                    onClick={() => {
                      this.analytcsClick(
                        'Professor Assistente eduCAT | Avaliações'
                      );
                    }}
                  />
                </Grid>
              </>

              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    img={IconVideos}
                    title="Buscar Recursos"
                    subtitle="Acesse o banco de recursos pedagógicos e encontre o que você procura."
                    theme={this.props.theme.primary}
                    history={history}
                    link="itens/tipo/2?Modal=True"
                    onClick={() => {
                      this.analytcsClick('Buscar recursos pedagógicos');
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    img={IconVideocreate}
                    title="Criar Recursos"
                    subtitle="Crie recursos pedagógicos que poderão ser utilizados em suas atividades."
                    theme={this.props.theme.primary}
                    history={history}
                    link="itens/new/dados/tipo/2"
                    onClick={() => {
                      this.analytcsClick('Criar recursos pedagógicos');
                    }}
                  />
                </Grid>
                <Grid
                  item
                  sm={6}
                  md={4}
                  xs={12}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <CardHomePage
                    imgRobot={IconRobot}
                    title="Professor Assistente eduCAT | Plano De Intervenção"
                    subtitle="Acesse o PAE, a inteligência artificial para a criação de plano de intervenção."
                    theme={this.props.theme.primary}
                    history={history}
                    link="personal-create/5/plano-intervencao"
                    onClick={() => {
                      this.analytcsClick(
                        'Professor Assistente eduCAT | Plano De Intervenção'
                      );
                    }}
                  />
                </Grid>
              </>

              <div
                style={{
                  width: '100%',
                  height: '2px',
                  backgroundColor: '#F5F5F5',
                  marginBottom: '24px',
                  marginTop: '40px'
                }}
              ></div>
            </Grid>

            <div className="card-body" style={{ backgroundColor: '#fafafa' }}>
              <TabsHomePage
                ref={(node) => {
                  this.itensCard = node;
                }}
                children={
                  <>
                    {fetchingItens ? (
                      <Loading />
                    ) : (
                      <Fragment>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={6}>
                            <div className="animated fadeIn">
                              <ItemTotal>
                                <label>Total</label>
                                <h3>{total}</h3>
                              </ItemTotal>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <div
                              className="animated fadeIn"
                              style={{ overflow: 'hidden' }}
                            >
                              <ItemTotalCalibrado>
                                <label style={{ color: 'white' }}>
                                  Calibrados
                                </label>
                                <Ruler />
                                <h3>{calibrados}</h3>
                              </ItemTotalCalibrado>
                            </div>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#5B5B5B'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <h3
                                    className="mt-2"
                                    style={{
                                      fontFamily: 'Quicksand',
                                      fontWeight: 'bold',
                                      color: this.props.theme.primary
                                        ? this.props.theme.primary
                                        : '#000000'
                                    }}
                                  >
                                    Áreas de conhecimento
                                  </h3>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'flex-end'
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: '#000000',
                                        fontFamily: 'Quicksand',
                                        fontWeight: '400',
                                        marginBottom: '2px'
                                      }}
                                    >
                                      Itens
                                    </label>
                                    <label
                                      style={{
                                        color: '#565656',
                                        fontFamily: 'Quicksand',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {soma_area_conhecimento}
                                    </label>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  {map(areas_conhecimento, (a) => (
                                    <Grid
                                      item
                                      container
                                      xs={12}
                                      sm={12}
                                      md={12}
                                    >
                                      <Grid item xs={8}>
                                        <p
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656'
                                          }}
                                        >
                                          {a.descricao}
                                        </p>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <span
                                          className="pull-right"
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656',
                                            marginRight: '58px'
                                          }}
                                        >
                                          {a.itens}
                                        </span>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#5B5B5B'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <h3
                                    className="mt-2"
                                    style={{
                                      fontFamily: 'Quicksand',
                                      fontWeight: 'bold',
                                      color: this.props.theme.primary
                                        ? this.props.theme.primary
                                        : '#000000'
                                    }}
                                  >
                                    Segmento/Etapa
                                  </h3>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'flex-end'
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: '#000000',
                                        fontFamily: 'Quicksand',
                                        fontWeight: '400',
                                        marginBottom: '2px'
                                      }}
                                    >
                                      Itens
                                    </label>

                                    <label
                                      style={{
                                        color: '#565656',
                                        fontFamily: 'Quicksand',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {soma_curso}
                                    </label>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  {map(curso, (a) => (
                                    <Grid
                                      item
                                      container
                                      xs={12}
                                      sm={12}
                                      md={12}
                                    >
                                      <Grid item xs={8}>
                                        <p
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656'
                                          }}
                                        >
                                          {a.descricao}
                                        </p>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <span
                                          className="pull-right"
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656',
                                            marginRight: '58px'
                                          }}
                                        >
                                          {a.itens}
                                        </span>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#5B5B5B'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <h3
                                    className="mt-2"
                                    style={{
                                      fontFamily: 'Quicksand',
                                      fontWeight: 'bold',
                                      color: this.props.theme.primary
                                        ? this.props.theme.primary
                                        : '#000000'
                                    }}
                                  >
                                    Série/Ano
                                  </h3>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'flex-end'
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: '#000000',
                                        fontFamily: 'Quicksand',
                                        fontWeight: '400',
                                        marginBottom: '2px'
                                      }}
                                    >
                                      Itens
                                    </label>

                                    <label
                                      style={{
                                        color: '#565656',
                                        fontFamily: 'Quicksand',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {soma_periodo}
                                    </label>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  {map(periodo, (a) => (
                                    <Grid
                                      item
                                      container
                                      xs={12}
                                      sm={12}
                                      md={12}
                                    >
                                      <Grid item xs={8}>
                                        <p
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656'
                                          }}
                                        >
                                          {a.descricao}
                                        </p>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <span
                                          className="pull-right"
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656',
                                            marginRight: '58px'
                                          }}
                                        >
                                          {a.itens}
                                        </span>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#5B5B5B'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <h3
                                    className="mt-2"
                                    style={{
                                      fontFamily: 'Quicksand',
                                      fontWeight: 'bold',
                                      color: this.props.theme.primary
                                        ? this.props.theme.primary
                                        : '#000000'
                                    }}
                                  >
                                    Tipos de objetos de apredizagem
                                  </h3>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'flex-end'
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: '#000000',
                                        fontFamily: 'Quicksand',
                                        fontWeight: '400',
                                        marginBottom: '2px'
                                      }}
                                    >
                                      Itens
                                    </label>

                                    <label
                                      style={{
                                        color: '#565656',
                                        fontFamily: 'Quicksand',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {soma_tipo}
                                    </label>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  {map(tipo, (a) => (
                                    <Grid
                                      item
                                      container
                                      xs={12}
                                      sm={12}
                                      md={12}
                                    >
                                      <Grid item xs={8}>
                                        <p
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656'
                                          }}
                                        >
                                          {a.descricao}
                                        </p>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <span
                                          className="pull-right"
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656',
                                            marginRight: '58px'
                                          }}
                                        >
                                          {a.itens}
                                        </span>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ArrowDropDownIcon
                                    style={{
                                      fontSize: '2.5rem',
                                      color: '#5B5B5B'
                                    }}
                                  />
                                }
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                              >
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}
                                >
                                  <h3
                                    className="mt-2"
                                    style={{
                                      fontFamily: 'Quicksand',
                                      fontWeight: 'bold',
                                      color: this.props.theme.primary
                                        ? this.props.theme.primary
                                        : '#000000'
                                    }}
                                  >
                                    Categorias de Objetos de Aprendizagem
                                  </h3>

                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'flex-end'
                                    }}
                                  >
                                    <label
                                      style={{
                                        color: '#000000',
                                        fontFamily: 'Quicksand',
                                        fontWeight: '400',
                                        marginBottom: '2px'
                                      }}
                                    >
                                      Itens
                                    </label>

                                    <label
                                      style={{
                                        color: '#565656',
                                        fontFamily: 'Quicksand',
                                        fontSize: '14px',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {soma_exame}
                                    </label>
                                  </div>
                                </div>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={2}>
                                  {map(exames, (a) => (
                                    <Grid
                                      item
                                      container
                                      xs={12}
                                      sm={12}
                                      md={12}
                                    >
                                      <Grid item xs={8}>
                                        <p
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656'
                                          }}
                                        >
                                          {a.descricao}
                                        </p>
                                      </Grid>
                                      <Grid item xs={4}>
                                        <span
                                          className="pull-right"
                                          style={{
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            fontFamily: 'Quicksand',
                                            color: '#565656',
                                            marginRight: '58px'
                                          }}
                                        >
                                          {a.itens}
                                        </span>
                                      </Grid>
                                    </Grid>
                                  ))}
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </Grid>
                      </Fragment>
                    )}
                  </>
                }
                children2={
                  <>
                    {fetchingAtividades &&
                    fetchingComponenteCurricular &&
                    fetchingAreaConhecimento &&
                    fetchingCurso &&
                    fetchingExames ? (
                      <Loading />
                    ) : (
                      <>
                        <Fragment>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <div className="animated fadeIn">
                                <ItemTotal>
                                  <label>Total</label>
                                  <h3>{count}</h3>
                                </ItemTotal>
                              </div>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Accordion defaultExpanded>
                                <AccordionSummary
                                  expandIcon={
                                    <ArrowDropDownIcon
                                      style={{
                                        fontSize: '2.5rem',
                                        color: '#5B5B5B'
                                      }}
                                    />
                                  }
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <div
                                    style={{
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    <h3
                                      className="mt-2"
                                      style={{
                                        fontFamily: 'Quicksand',
                                        fontWeight: 'bold',
                                        color: this.props.theme.primary
                                          ? this.props.theme.primary
                                          : '#000000'
                                      }}
                                    >
                                      Áreas de conhecimento
                                    </h3>

                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                      }}
                                    >
                                      <label
                                        style={{
                                          color: '#000000',
                                          fontFamily: 'Quicksand',
                                          fontWeight: '400',
                                          marginBottom: '2px'
                                        }}
                                      >
                                        Itens
                                      </label>

                                      <label
                                        style={{
                                          color: '#565656',
                                          fontFamily: 'Quicksand',
                                          fontSize: '14px',
                                          fontWeight: '400'
                                        }}
                                      >
                                        {soma_areas_do_conhecimento}
                                      </label>
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid container spacing={2}>
                                    {areas_do_conhecimento.map((a) => {
                                      let descricao = a.descricao;
                                      switch (descricao) {
                                        case '1':
                                          descricao =
                                            'Linguagens, Códigos e suas Tecnologias';
                                          break;
                                        case '2':
                                          descricao =
                                            'Matemática e suas Tecnologias';
                                          break;
                                        case '3':
                                          descricao =
                                            'Ciências da Natureza e suas Tecnologias';
                                          break;
                                        case '4':
                                          descricao =
                                            'Ciências Humanas e suas Tecnologias';
                                          break;
                                        case '5':
                                          descricao = 'Ensino Religioso';
                                          break;
                                        case '8':
                                          descricao = 'Redação';
                                          break;
                                        case '9':
                                          descricao = 'Educação Tecnológica';
                                          break;
                                        default:
                                          break;
                                      }

                                      return (
                                        <Grid
                                          item
                                          container
                                          xs={12}
                                          sm={12}
                                          md={12}
                                        >
                                          <Grid item xs={8}>
                                            <p
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '400',
                                                fontFamily: 'Quicksand',
                                                color: '#565656'
                                              }}
                                            >
                                              {descricao}
                                            </p>
                                          </Grid>
                                          <Grid item xs={4}>
                                            <span
                                              className="pull-right"
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '400',
                                                fontFamily: 'Quicksand',
                                                color: '#565656',
                                                marginRight: '58px'
                                              }}
                                            >
                                              {a.itens}
                                            </span>
                                          </Grid>
                                        </Grid>
                                      );
                                    })}
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Accordion defaultExpanded>
                                <AccordionSummary
                                  expandIcon={
                                    <ArrowDropDownIcon
                                      style={{
                                        fontSize: '2.5rem',
                                        color: '#5B5B5B'
                                      }}
                                    />
                                  }
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <div
                                    style={{
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    <h3
                                      className="mt-2"
                                      style={{
                                        fontFamily: 'Quicksand',
                                        fontWeight: 'bold',
                                        color: this.props.theme.primary
                                          ? this.props.theme.primary
                                          : '#000000'
                                      }}
                                    >
                                      Segmento/Etapa
                                    </h3>

                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                      }}
                                    >
                                      <label
                                        style={{
                                          color: '#000000',
                                          fontFamily: 'Quicksand',
                                          fontWeight: '400',
                                          marginBottom: '2px'
                                        }}
                                      >
                                        Itens
                                      </label>

                                      <label
                                        style={{
                                          color: '#565656',
                                          fontFamily: 'Quicksand',
                                          fontSize: '14px',
                                          fontWeight: '400'
                                        }}
                                      >
                                        {soma_nivel_curso}
                                      </label>
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid container spacing={2}>
                                    {/* .filter((mapResponse) => (mapResponse.oculto !== true)) */}
                                    {map(nivel_curso, (a) => (
                                      <Grid
                                        item
                                        container
                                        xs={12}
                                        sm={12}
                                        md={12}
                                      >
                                        <Grid item xs={8}>
                                          <p
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656'
                                            }}
                                          >
                                            {a.descricao}
                                          </p>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <span
                                            className="pull-right"
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656',
                                              marginRight: '58px'
                                            }}
                                          >
                                            {a.itens}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                            </Grid>

                            <Grid item xs={12} sm={6} md={6}>
                              <Accordion defaultExpanded>
                                <AccordionSummary
                                  expandIcon={
                                    <ArrowDropDownIcon
                                      style={{
                                        fontSize: '2.5rem',
                                        color: '#5B5B5B'
                                      }}
                                    />
                                  }
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <div
                                    style={{
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    <h3
                                      className="mt-2"
                                      style={{
                                        fontFamily: 'Quicksand',
                                        fontWeight: 'bold',
                                        color: this.props.theme.primary
                                          ? this.props.theme.primary
                                          : '#000000'
                                      }}
                                    >
                                      Componente Curricular
                                    </h3>

                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                      }}
                                    >
                                      <label
                                        style={{
                                          color: '#000000',
                                          fontFamily: 'Quicksand',
                                          fontWeight: '400',
                                          marginBottom: '2px'
                                        }}
                                      >
                                        Itens
                                      </label>
                                      <label
                                        style={{
                                          color: '#565656',
                                          fontFamily: 'Quicksand',
                                          fontSize: '14px',
                                          fontWeight: '400'
                                        }}
                                      >
                                        {soma_componente_curricular}
                                      </label>
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid container spacing={2}>
                                    {map(componente_curricular, (a) => (
                                      <Grid
                                        item
                                        container
                                        xs={12}
                                        sm={12}
                                        md={12}
                                      >
                                        <Grid item xs={8}>
                                          <p
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656'
                                            }}
                                          >
                                            {a.descricao}
                                          </p>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <span
                                            className="pull-right"
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656',
                                              marginRight: '58px'
                                            }}
                                          >
                                            {a.itens}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                            </Grid>

                            {/* Ocultando "Avaliações" */}
                            {/* <Grid item xs={12} sm={6} md={6}>
                              <Accordion defaultExpanded>
                                <AccordionSummary
                                  expandIcon={
                                    <ArrowDropDownIcon
                                      style={{
                                        fontSize: '2.5rem',
                                        color: '#5B5B5B'
                                      }}
                                    />
                                  }
                                  aria-controls="panel1d-content"
                                  id="panel1d-header"
                                >
                                  <div
                                    style={{
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between'
                                    }}
                                  >
                                    <h3
                                      className="mt-2"
                                      style={{
                                        fontFamily: 'Quicksand',
                                        fontWeight: 'bold',
                                        color: this.props.theme.primary
                                          ? this.props.theme.primary
                                          : '#000000'
                                      }}
                                    >
                                      Avaliações
                                    </h3>

                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end'
                                      }}
                                    >
                                      <label
                                        style={{
                                          color: '#000000',
                                          fontFamily: 'Quicksand',
                                          fontWeight: '400',
                                          marginBottom: '2px'
                                        }}
                                      >
                                        Itens
                                      </label>

                                      <label
                                        style={{
                                          color: '#565656',
                                          fontFamily: 'Quicksand',
                                          fontSize: '14px',
                                          fontWeight: '400'
                                        }}
                                      >
                                        {soma_exame_avaliacao}
                                      </label>
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid container spacing={2}>
                                    {map(exame_avaliacao, (a) => (
                                      <Grid
                                        item
                                        container
                                        xs={12}
                                        sm={12}
                                        md={12}
                                      >
                                        <Grid item xs={8}>
                                          <p
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656'
                                            }}
                                          >
                                            {a.descricao}
                                          </p>
                                        </Grid>
                                        <Grid item xs={4}>
                                          <span
                                            className="pull-right"
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '400',
                                              fontFamily: 'Quicksand',
                                              color: '#565656',
                                              marginRight: '58px'
                                            }}
                                          >
                                            {a.itens}
                                          </span>
                                        </Grid>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                            </Grid> */}
                          </Grid>
                        </Fragment>
                      </>
                    )}
                  </>
                }
              />
            </div>
          </>
        ) : (
          <>
            {this.shouldDisplay('dashboard.ocult_cards') ? (
              <Grid container style={{ marginTop: '20px' }}>
                <ContainerSection
                  title="Eventos"
                  subtitle="Eventos relacionados ao dia a dia."
                  >
                  <ContainerCalendario/>
                </ContainerSection>
              </Grid>
            ) : (
              <Container maxWidth="lg">
                {this.shouldDisplay('dashboard.banner_devolutiva') && (
                  <Grid container item spacing={3}>
                    <Grid item xs={12}>
                      <img
                        className="img-plurall"
                        src={bannerRelatorios}
                        style={{ width: '100%' }}
                        onClick={() => {
                          history.push(`/devolutiva`);
                        }}
                      />
                    </Grid>
                  </Grid>
                )}

                  <Grid item xs={12} style={{ marginLeft: '1rem' }}>
                    <Grid item container xs={12} spacing={3}>
                      {dadosCards.map((dados, index) => (
                        <Grid item xs={12} md={4} key={index}>
                          <div
                            style={{
                              width: '100%',
                              height: '118px',
                              borderRadius: '16px',
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                              background: '#FFFFFF',
                              boxShadow:
                                '0px 2px 8.5px rgba(129, 129, 129, 0.25)'
                            }}
                          >
                            <div
                              style={{
                                width: '67.46px',
                                height: '67.46px',
                                background: '#EEE3FF',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '50px',
                                marginRight: '1rem',
                                marginLeft: '1rem'
                              }}
                            >
                              <PieChartIcon
                                style={{
                                  width: '52.22px',
                                  height: '52.3px',
                                  color: '#FFFFFF'
                                }}
                              />
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                maxWidth: '200px'
                              }}
                            >
                              <label
                                style={{ fontSize: '9px', color: '#9C9A9A' }}
                              >
                                {dados.subTitle}
                              </label>

                              <a
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  color: '#7229E6'
                                }}
                                href={dados.url}
                              >
                                {dados.nome}
                              </a>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
              </Container>
            )}
          </>
        )}
      </>
    );
  }

  render() {
    const { encomendas } = this.state;

    return (
      <div className="container dashboard-main">
        <div className="row">
          <div className="col-sm-12">{this.renderItens()}</div>
        </div>
      </div>
    );
  }
}

export default withTheme(HomePage);
